import React from 'react';
import Icon from '../../../components/AppIcon';

const KPIPanel = ({
  kpis,
  title = "Program KPIs",
  subtitle = "Key performance indicators and quality metrics",
}) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'excellent':
        return 'text-success bg-success/10';
      case 'good':
        return 'text-primary bg-primary/10';
      case 'warning':
        return 'text-warning bg-warning/10';
      case 'critical':
        return 'text-error bg-error/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'excellent':
        return 'CheckCircle2';
      case 'good':
        return 'ThumbsUp';
      case 'warning':
        return 'AlertTriangle';
      case 'critical':
        return 'AlertCircle';
      default:
        return 'Info';
    }
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-sm border border-border h-full">
      <div className="mb-4 md:mb-6">
        <h3 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground mb-2">
          {title}
        </h3>
        <p className="text-sm md:text-base text-muted-foreground">
          {subtitle}
        </p>
      </div>
      <div className="space-y-4 md:space-y-6">
        {kpis?.map((kpi, index) => (
          <div key={index} className="border-b border-border last:border-b-0 pb-4 md:pb-6 last:pb-0">
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1">
                <h4 className="text-sm md:text-base font-semibold text-foreground mb-1">
                  {kpi?.title}
                </h4>
                <p className="text-xs md:text-sm text-muted-foreground">
                  {kpi?.description}
                </p>
              </div>
              <div className={`flex-shrink-0 w-8 h-8 md:w-10 md:h-10 rounded-lg ${getStatusColor(kpi?.status)} flex items-center justify-center ml-3`}>
                <Icon name={getStatusIcon(kpi?.status)} size={16} className="md:w-5 md:h-5" />
              </div>
            </div>

            <div className="space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground">
                  {kpi?.value}
                  <span className="text-sm md:text-base text-muted-foreground ml-1">{kpi?.unit}</span>
                </span>
                {kpi?.change && (
                  <span className={`text-xs md:text-sm flex items-center gap-1 ${kpi?.changeDirection === 'up' ? 'text-success' : 'text-error'}`}>
                    <Icon name={kpi?.changeDirection === 'up' ? 'ArrowUp' : 'ArrowDown'} size={14} />
                    {kpi?.change}
                  </span>
                )}
              </div>

              {kpi?.benchmark && (
                <div className="flex items-center justify-between text-xs md:text-sm text-muted-foreground">
                  <span>Benchmark: {kpi?.benchmark}{kpi?.unit}</span>
                  <span className={kpi?.value >= kpi?.benchmark ? 'text-success' : 'text-error'}>
                    {kpi?.value >= kpi?.benchmark ? 'Above' : 'Below'} target
                  </span>
                </div>
              )}

              {kpi?.facilities && (
                <button className="text-xs md:text-sm text-primary hover:underline flex items-center gap-1 mt-2">
                  <Icon name="Building2" size={14} />
                  View {kpi?.facilities} facility breakdown
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KPIPanel;